import { QueryClient, QueryClientProvider } from "react-query";
import "react-responsive-modal/styles.css";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import { Toaster } from "sonner";
import MainContent from "./components/MainContent";
import { AuthProvider } from "./context/Auth/CombinedAuthContext";
import "./styles/App.scss";

const queryClient = new QueryClient();

export default function App() {
	return (
		<AuthProvider>
			<QueryClientProvider client={queryClient}>
				<MainContent />
				<Toaster richColors position="top-center" />
			</QueryClientProvider>
		</AuthProvider>
	);
}
